import {getAllManufacturersList, INTERNAL_MANUFACTURER_KEY, USER_MANUFACTURER_KEY} from "src/utils/manufacturerUtil";

export const saveDiscount = async (
    id,
    discount,
    projectId,
    serverConfirmedDiscounts,
    setServerConfirmedDiscounts,
    dispatchDiscountPercents,
    updateManufacturerDiscount,
    updateService
) => {
  let updateFn;

  const data = {project_id: projectId, discount_percent: discount};

  if (id.indexOf("ipmi_") === 0) {
    data["internal_product_manufacturer_id"] = id.replace("ipmi_", "");
    updateFn = updateManufacturerDiscount;
  } else if (id.indexOf("umi_") === 0) {
    data["user_manufacturer_id"] = id.replace("umi_", "");
    updateFn = updateManufacturerDiscount;
  } else if (id.indexOf("si_") === 0) {
    data["service_id"] = id.replace("si_", "");
    updateFn = updateService;
  } else {
    return console.log("invalid id", id);
  }

  if (
      serverConfirmedDiscounts[id] &&
      discount == serverConfirmedDiscounts[id]
  ) {
    dispatchDiscountPercents({id, value: discount, type: "update"});
    return console.debug(
        "didnt send discount since it matches with the server value",
        id,
        discount,
        serverConfirmedDiscounts[id]
    );
  }

  await updateFn(data)

  setServerConfirmedDiscounts({
    ...serverConfirmedDiscounts,
    [id]: discount,
  })
  dispatchDiscountPercents({id, value: discount, type: "update"});
};

export const getServiceNameToId = (setServiceNameToId, quoteResponse) => {
  const nameToId = {};
  const serviceArr = quoteResponse["quote-project-custom"].data;

  if (Array.isArray(serviceArr)) {
    serviceArr.forEach((elem) => {
      nameToId[elem.product_name.split("(#")[0]] = `si_${elem.custom_item_id}`;
    });
  }

  return (
      typeof setServiceNameToId === "function" && setServiceNameToId(nameToId)
  );
};

export const getSavedDiscounts = (
    allManufacturerDiscountForProject,
    quoteResponse,
    serverConfirmedDiscounts,
    dispatchDiscountPercents,
    setServerConfirmedDiscounts,
) => {
  const payload = {};
  const intArr = allManufacturerDiscountForProject.internal_manufacturer_discount;
  const userArr = allManufacturerDiscountForProject.user_manufacturer_discount;
  const serviceArr = quoteResponse["quote-project-custom"].data;

  if (Array.isArray(intArr)) {
    intArr.forEach((elem) => {
      const asdkey = `ipmi_${elem.internal_product_manufacturer_id}`;
      payload[asdkey] = +elem.discount || 0;
      setServerConfirmedDiscounts({
        ...serverConfirmedDiscounts,
        [asdkey]: payload[asdkey],
      });
    });
  }

  if (Array.isArray(userArr)) {
    userArr.forEach((elem) => {
      const dfgkey = `umi_${elem.user_manufacturer_id}`;
      payload[dfgkey] = +elem.discount || 0;
      setServerConfirmedDiscounts({
        ...serverConfirmedDiscounts,
        [dfgkey]: payload[dfgkey],
      });
    });
  }

  if (Array.isArray(serviceArr)) {
    serviceArr.forEach((elem) => {
      const ghkey = `si_${elem.custom_item_id}`;
      payload[ghkey] = +elem.discount || 0;
      setServerConfirmedDiscounts({
        ...serverConfirmedDiscounts,
        [ghkey]: payload[ghkey],
      });
    });
  }

  typeof dispatchDiscountPercents === "function" &&
  dispatchDiscountPercents({
    type: "fetch",
    payload,
  });
};

export const getManufacturerNameToId = (
    manufacturerRecommendationForProject,
    allManufacturerDiscountForProject,
    setManufacturerNameToId,
    searchQuery = "",
    filterFn = null
) => {
  const nameToId = {};

  getAllManufacturersList(
      manufacturerRecommendationForProject,
      allManufacturerDiscountForProject,
      searchQuery,
      filterFn,
    ).forEach((elem) => {
    if (INTERNAL_MANUFACTURER_KEY in elem) {
      nameToId[
          elem.manufacturer_name
          ] = `ipmi_${elem.internal_product_manufacturer_id}`;
    } else if (USER_MANUFACTURER_KEY in elem) {
      nameToId[elem.manufacturer_name] = `umi_${elem.user_manufacturer_id}`;
    }
  });

  return (
      typeof setManufacturerNameToId === "function" &&
      setManufacturerNameToId(nameToId)
    );
};
